import axios from "axios";


type TokenExchangeResponse = {
    token: string;
}

export async function exchangeToken(idToken: string): Promise<TokenExchangeResponse> {
    const response = await axios.post("/auth/google-login", JSON.stringify({ idToken }), {
        headers: {
            "Content-Type": "application/json"
        }
    });
    return response.data as TokenExchangeResponse;
}